"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importDefault(require("react"));

var context_1 = require("./context");

var root_1 = require("./styled/root");

var Accordion = function Accordion(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      children = _a.children,
      className = _a.className,
      id = _a.id,
      isDisabled = _a.isDisabled,
      isInverse = _a.isInverse,
      isExpanded = _a.isExpanded;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Accordion',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var controlsId = (0, use_id_1.useId)(id);
  var contextValue = {
    controlsId: controlsId,
    isExpanded: isExpanded,
    isDisabled: isDisabled,
    isInverse: isInverse
  };
  return react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    "data-testid": testID,
    isInverse: isInverse,
    isDisabled: isDisabled
  }, react_1.default.createElement(context_1.AccordionContext.Provider, {
    value: contextValue
  }, children));
};

var AccordionWithSpace = (0, ui_helper_with_space_1.withSpace)(Accordion);
exports.Accordion = AccordionWithSpace;